import '../_prototypes/parsley';
import bootbox from '../_prototypes/bootbox';

$('[name="email"]').focus();


$('#forgotPassword')
    .parsley()
    .on('form:submit', function () {
        $('#pass-reset-submit').attr('disabled', true);
        const email = $('#email').val() || '';

        $.ajax({
            type: 'POST',
            url: './forgot-password',
            data: {
                email,
            },
            success: function (response) {
                // If request didn't work for some reason
                if (!response.success) {
                    bootbox.alert({
                        size: 'medium',
                        title: 'Error Sending Request',
                        message: 'Failed to send your request. Please try again or contact support.',
                    });
                    $('#pass-reset-submit').attr('disabled', false);
                    return false;
                }
                bootbox.alert({
                    size: 'medium',
                    title: 'Request Sent',
                    message: 'Your request was received. If that address is on file, you should get an email soon with further instructions for resetting your password.',
                });
                $('#forgotPassword').addClass('d-none');
                $('#request-sent-message').removeClass('d-none');
                return false;
            },
            error: function () {
                // If there was an error with request
                bootbox.alert({
                    size: 'medium',
                    title: 'Error Sending Request',
                    message: 'Failed to send your request. Please try again or contact support.',
                });
                $('#pass-reset-submit').attr('disabled', false);
                return false;
            },
        });

        return false;
    });
